<template>
  <div id='rootDiv'>
    <alert/>
    <webgl-detect/>
    <router-view :key="$route.fullPath">
    </router-view>
  </div>
</template>

<script>
import Alert from './components/Notifications/Alert'
import WebGLDetect from './components/WebGLDetect'

export default {
  name: 'app',
  components: {
    Alert,
    'webgl-detect': WebGLDetect
  }
}
</script>
<style lang="scss">
@import '../node_modules/materialize-css/dist/css/materialize.css';
@import '../node_modules/font-awesome/css/font-awesome.min.css';
@import url('https://fonts.googleapis.com/icon?family=Material+Icons');

#rootDiv {
  font-family: 'Libre-Franklin', sans-serif;
}
.bold {
  font-weight: bold;
}
.startjob {
  margin: 0;
}
.startjobtitle {
  margin: 40px 12%;
}
.upspace {
  margin-top: 30%
}
.upsmallspace {
  margin-top: 10%
}
.buymodal {
  height:100%;
  width:100%;
  margin:0;
}
.my-dropdown-dd {
  z-index: 10;
}
.buymodalblue {
  background-color:$atlas-blue;
}
.a3dbg {
  background-color:$btn-color;
}
.a3dlightgray {
  background-color: $bg-gray;
}
.a3d {
  font-family: 'Libre-Franklin', sans-serif;

  &.color {
    color: $atlas-blue;
  }

  &.btn {
    border-radius: 0;
    text-transform: none;
    font-weight: bold;
    box-shadow: 0 0 0;
    background-color: $btn-color;

    &.small {
      height: auto;
      line-height: 1;
      padding: 0.5em 1em;
      font-size: 0.8em;
    }

    &:hover {
      background-color: $btn-hover;
    }

    &.inv {
      border: 1px solid $btn-color;
      background-color: #FFFFFF;
      color: $btn-color;
      &:hover {
        border-color: $btn-hover;
        background-color: #FFFFFF;
        color: $btn-hover;
      }

      &.dark {
        background: inherit;
        border-color: black;
        color: black;
        &:hover {
          background-color: $btn-color;
        }
      }
    }
  }

  &.logo {
    display: block;
    width: 150px;
    height: 100%;
  }

  &.bell {
    margin: 20px;
    height: 20px;
    display: block;
  }

  &.splash {
    margin-top: 15%;
  }
}

.tooltip-wrp {
  position: relative;

  .tooltip {
    margin: 0 8px;
    position: relative;

    .tooltipvalue {
      position: absolute;
      width: 40px;
      text-align: center;
      top: -20px;
      margin-left: -20px;
      background-color: $atlas-blue-dark;
      border-radius: 12px;
      color: #fff;
      white-space: nowrap;
      z-index: 0;

      &:after {
        content: "";
        position: absolute;
        top: 100%;
        left: 50%;
        margin-left: -5px;
        margin-top: -7px;
        width: 10px;
        height: 10px;
        background-color: $atlas-blue-dark;
        transform: rotate(45deg);
        z-index: -1;
      }
    }
  }
}

input[type="range"]::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: $atlas-blue-dark;
  cursor: pointer;
  margin-top: -7px;
}
input[type="range"]::-moz-range-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: $atlas-blue-dark;
  cursor: pointer;
  margin-top: -7px;
}
input[type="range"]::-ms-tooltip {
  display: none;
}
input[type="range"]::-ms-thumb {
  appearance: none;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: $atlas-blue-dark;
  cursor: pointer;
  top: -4px;
}
input[type="range"] {
  border: none;
  height: 30px;
  margin: 0;
}

input[type="checkbox"].filled-in:checked + label:after {
  border-color: $atlas-blue-dark;
  background-color: $atlas-blue-dark;
}

nav.a3d {
  background-color: $menu-gray;
}

i.material-icons.a3d {
  font-family: 'Material Icons' !important;
}

.progress {
  .indeterminate, .determinate {
    background-color: $btn-color;
  }
}

.v--modal-box {
  overflow: auto!important;
  max-height: 90vh;
}

.c {
  > input[type=checkbox] {
    position: inherit !important;
    opacity: 1 !important;
    pointer-events: auto;
  }
  > div {
    > input {
      height: 1rem !important;
    }
  }

  > select {
    display: inherit;
    color: #000;
    height: auto;
    padding: 0;

    &:disabled {
      background-color: #c5c5c5;
    }
  }
}

// Make Files and Job sections expand to bottom
html, body, #rootDiv {
  /*height: 100%;*/
}
</style>



// WEBPACK FOOTER //
// App.vue?7ea87458